import { Component, EventEmitter, Input, Output, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { JsonPipe } from '@angular/common';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'crm-board-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatCardModule, JsonPipe, CommonModule],
})
export class CrmBoardCardComponent<T> {
  @Input({ required: true }) item?: T;
  @Input() cardTemplate?: TemplateRef<unknown>;
  @Output() clicked: EventEmitter<void> = new EventEmitter();

  public handleClick(): void {
    this.clicked.emit();
  }
}
